import * as React from "react";
import Box from "@mui/material/Box";

import PropTypes, { node } from "prop-types";
import { useNavigate } from "react-router-dom";
import { TreeView } from "@mui/x-tree-view/TreeView";
import { TreeItem } from "@mui/x-tree-view/TreeItem";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ChangelogModalWrapper from "../ChangelogModal/ChangelogModalWrapper";

export default function RichObjectTreeView(props) {
  const { data } = props;

  // Debug logs
  console.log("RichObjectTreeView props:", props);
  console.log("RichObjectTreeView data:", data);
  console.log("RichObjectTreeView data type:", typeof data);
  console.log("RichObjectTreeView data isArray:", Array.isArray(data));
  console.log(
    "RichObjectTreeView data length:",
    data ? data.length : "data is null/undefined"
  );

  const navigate = useNavigate();
  const [state, setState] = React.useState({
    treeDefaultExpanded: ["PO", "SO"],
  });

  // State for showing changelog modal
  const [showChangelog, setShowChangelog] = React.useState(false);
  const [changelogContent, setChangelogContent] = React.useState("");

  const handleVersionClick = () => {
    // ใช้ข้อมูล changelog ทดสอบ

    setChangelogContent(testChangelogData);
    setShowChangelog(true);
  };

  const handleCloseChangelogModal = () => {
    setShowChangelog(false);
    setChangelogContent("");
  };
  const lineTo = (idMenu) => {
    switch (idMenu) {
      case "jobtohonda":
        navigate(`/PSToHonda?mid=${idMenu}`);
        break;
      case "10401":
        navigate(`/PSORDERPR?mid=${idMenu}`);
        break;
      case "10901":
        navigate(`/PSPURCHASE?mid=${idMenu}`);
        break; //
      case "20501":
        navigate(`/PSquot?mid=${idMenu}`);
        break; //บันทึกใบเสนอราคาขาย
      case "20701":
        navigate(`/PSSalesOrder?mid=${idMenu}`);
        break; //บันทึกใบสั่งขาย/สั่งจัดสินค้า
      case "20801":
        navigate(`/PSSaleAndService?mid=${idMenu}`);
        break; //บันทึกขายสินค้า/บริการ
      case "20901":
        navigate(`/PSReturnProduct?mid=${idMenu}`);
        break; //บันทึกใบขอรับคืนสินค้า
      case "21001":
        navigate(`/PSSaleRet?mid=${idMenu}`);
        break; //บันทึกรับคืนสินค้า/ลดหนี้
      case "30401":
        navigate(`/PSApotherdebt?mid=${idMenu}`);
        break; //บันทึกตัดบัญชีเจ้าหนี้/จ่ายชำระ
      case "30801":
        navigate(`/PSPAYMENT?mid=${idMenu}`);
        break; //บันทึกตัดบัญชีเจ้าหนี้/จ่ายชำระ
      case "40101":
        navigate(`/Savecustomer?mid=${idMenu}`);
        break; //บันทึกข้อมูลลูกค้า
      case "40201":
        navigate(`/PSARDeposit?mid=${idMenu}`);
        break; // บันทึกรับเงินล่วงหน้า/เงินมัดจำ
      case "40301":
        navigate(`/PSARCNDeposit?mid=${idMenu}`);
        break; // บันทึกรับเงินล่วงหน้า/เงินมัดจำ
      case "40601":
        navigate(`/PSPaybill?mid=${idMenu}`);
        break; // บันทึกใบวางบิล
      case "40801":
        navigate(`/PSReceipt?mid=${idMenu}`);
        break; // ตัดบัญชีลูกหนี้/รับชำระ
      case "50101":
        navigate(`/Inventory?mid=${idMenu}`);
        break; //บันทึกข้อสินค้า
      case "50301":
        navigate(`/CSWithdrawalrequest?mid=${idMenu}`);
        break; // บันทึกใบขอเบิก
      case "50401":
        navigate(`/CSProductbring?mid=${idMenu}`);
        break; // บันทึกใบขอเบิก
      case "50801":
        navigate(`/PSSaveAskTransfer?mid=${idMenu}`);
        break; //บันทึกใบขอรับคืนสินค้า
      case "50803":
        navigate(`/PSSaveTransfer?mid=${idMenu}`);
        break; //บันทึกใบขอรับคืนสินค้า
      case "60504":
        navigate(`/PSCsbankcashin?mid=${idMenu}`);
        break; // บันทึกฝากเงินสด
      case "80901":
        navigate(`/PSExpenses?mid=${idMenu}`);
        break; //บันทึกค่าใฃ้จ่ายอื่นๆ
      case "81001":
        navigate(`/PSOtherBad?mid=${idMenu}`);
        break; //บันทึกรายได้อื่นๆ
      case "A0630":
        navigate(`/PSCC_SaleOrder?mid=${idMenu}`);
        break; //ปิดใบสั่งขาย
      case "51401":
        navigate(`/PSSTKJOBORDER?mid=${idMenu}`);
        break; //ปิดใบสั่งขาย
      case "50601":
        navigate(`/PSFG?mid=${idMenu}`);
        break; //ปิดใบสั่งขาย
      default:
        navigate(`/home`);
        break;
    }
  };

  return (
    <>
      <Box
        sx={{
          minHeight: 110,
          flexGrow: 1,
          overflowY: "scroll",
        }}
      >
        <TreeView
          aria-label="file system navigator"
          defaultCollapseIcon={<ExpandMoreIcon />}
          defaultExpandIcon={<ChevronRightIcon />}
          defaultExpanded={state.treeDefaultExpanded}
          key={"TreeView"}
        >
          {(data || []).map((node, index) => {
            console.log(`RichObjectTreeView node[${index}]:`, node);
            console.log(
              `RichObjectTreeView node[${index}] submenu:`,
              node.submenu
            );
            console.log(
              `RichObjectTreeView node[${index}] submenu type:`,
              typeof node.submenu
            );
            console.log(
              `RichObjectTreeView node[${index}] submenu isArray:`,
              Array.isArray(node.submenu)
            );

            // Generate unique key with fallback
            const nodeKey = node?.MENUID || `node-${index}`;
            const nodeId = node?.MENUID || `node-${index}`;
            const nodeName = node?.MENUNAME || `Menu ${index}`;

            return (
              <TreeItem
                key={"LI" + nodeKey}
                nodeId={"LI" + nodeId}
                label={nodeName}
                onClick={() =>
                  (node?.submenu || []).length > 0 ? null : lineTo(node?.MENUID)
                }
              >
                {/* l1 */}
                {(node?.submenu || []).length > 0
                  ? (node.submenu || []).map((nodeL1, indexL1) => {
                      console.log(
                        `RichObjectTreeView nodeL1[${indexL1}]:`,
                        nodeL1
                      );
                      console.log(
                        `RichObjectTreeView nodeL1[${indexL1}] submenu:`,
                        nodeL1?.submenu
                      );

                      // Generate unique key with fallback for level 1
                      const nodeL1Key =
                        nodeL1?.MENUID || `node-${index}-${indexL1}`;
                      const nodeL1Id =
                        nodeL1?.MENUID || `node-${index}-${indexL1}`;
                      const nodeL1Name =
                        nodeL1?.MENUNAME || `Menu ${index}-${indexL1}`;

                      return (
                        <>
                          <TreeItem
                            nodeId={"LII" + nodeL1Id}
                            key={"LII" + nodeL1Key}
                            label={nodeL1Name}
                            onClick={() =>
                              (nodeL1?.submenu || []).length > 0
                                ? null
                                : lineTo(nodeL1?.MENUID)
                            }
                          >
                            {/* l2 */}
                            {(nodeL1?.submenu || []).length > 0
                              ? // nodeL1.submenu.length
                                (nodeL1.submenu || []).map(
                                  (nodeL2, indexL2) => {
                                    console.log(
                                      `RichObjectTreeView nodeL2[${indexL2}]:`,
                                      nodeL2
                                    );

                                    // Generate unique key with fallback for level 2
                                    const nodeL2Key =
                                      nodeL2?.MENUID ||
                                      `node-${index}-${indexL1}-${indexL2}`;
                                    const nodeL2Id =
                                      nodeL2?.MENUID ||
                                      `node-${index}-${indexL1}-${indexL2}`;
                                    const nodeL2Name =
                                      nodeL2?.MENUNAME ||
                                      `Menu ${index}-${indexL1}-${indexL2}`;

                                    return (
                                      <>
                                        <TreeItem
                                          key={"LI3" + nodeL2Key}
                                          nodeId={"LI3" + nodeL2Id}
                                          label={nodeL2Name}
                                          onClick={() => lineTo(nodeL2?.MENUID)}
                                        ></TreeItem>
                                      </>
                                    );
                                  }
                                )
                              : //  < TreeItem nodeId="2" label="Calendar" />
                                null}
                            {/* end l2 */}
                          </TreeItem>
                        </>
                      );
                    })
                  : null}
                {/* end l1 */}
              </TreeItem>
            );
          })}
        </TreeView>
      </Box>
      <Box
        sx={{
          fontSize: "12px",
          alignItems: "flex-end",
          textAlign: "end",
          paddingRight: 3,
        }}
      >
        <span
          style={{ cursor: "pointer", textDecoration: "none" }}
          onClick={handleVersionClick}
        >
          {process.env.REACT_APP_MAINURL} V.{process.env.REACT_APP_VERSION}
        </span>
      </Box>
      {/* Changelog Modal */}
      <ChangelogModalWrapper
        open={showChangelog}
        onClose={() => setShowChangelog(false)}
        changelog={changelogContent}
      />
    </>
  );
}
RichObjectTreeView.propTypes = {
  data: PropTypes.any.isRequired,
};

RichObjectTreeView.defaultProps = {
  data: [],
};

// ฟังก์ชันสำหรับตรวจสอบข้อมูล changelog
function testChangelogData(data) {
  if (!Array.isArray(data)) return false;
  return data.every(
    (item) =>
      item.hasOwnProperty("version") &&
      item.hasOwnProperty("date") &&
      item.hasOwnProperty("changes")
  );
}
